export default __webpack_public_path__ + "static/media/logo-navigation.f49ea792.png";